import { Entity } from '../../Model/Implementation/Entity';
import { createTransactionalModel, getModel } from '../../../@Util/TransactionalModelV2';

export default function getFreshTransactionalEntity(entity: Entity)
{
    return createTransactionalModel(
        getModel(entity));
}
